import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SelectItem } from 'primeng/api';

@Injectable()

export class DropdownService {
    constructor(
    ) {

    }
    public dropdown: SelectItem[];
   
    generateDropdownIdSCode(List: any[]) {
        this.dropdown = [];
        this.dropdown.push({ label: 'Seleccione', value: null });
        for (const dr of List) {
            this.dropdown.push({ label: dr.name, value: dr.id });
        }
        return this.dropdown;
    }

    generateDropdownIdSESCode(List: any[]) {
        this.dropdown = [];
        this.dropdown.push({ label: 'Seleccione', value: null });
        for (const dr of List) {
            this.dropdown.push({ label: dr.nombre, value: dr.id });
        }
        return this.dropdown;
    }
    generateDropdownId(List: any[]) {
        this.dropdown = [];
        this.dropdown.push({ label: 'Seleccione', value: null });
        for (const dr of List) {
            this.dropdown.push({ label: dr.code + ': ' + dr.name, value: dr.id });
        }
        return this.dropdown;
    }
    generateDropdownName(List: any[]) {
        this.dropdown = [];
        this.dropdown.push({ label: 'Seleccione', value: null });
        for (const dr of List) {
            this.dropdown.push({ label: dr.code + ': ' + dr.name, value: dr.name });
        }
        return this.dropdown;
    }
    generateDropdownNameSCode(List: any[]) {
        this.dropdown = [];
        this.dropdown.push({ label: 'Seleccione', value: null });
        for (const dr of List) {
            this.dropdown.push({ label: dr.name, value: dr.name });
        }
        return this.dropdown;
    }
    generateDropdownEntity(List: any[]) {
        this.dropdown = [];
        this.dropdown.push({ label: 'Seleccione', value: null });
        for (const dr of List) {
            this.dropdown.push({ label: dr.code + ': ' + dr.name, value: dr });
        }
        return this.dropdown;
    }
    generateDropdownEntitySCode(List: any[]) {
        this.dropdown = [];
        this.dropdown.push({ label: 'Seleccione', value: null });
        for (const dr of List) {
            this.dropdown.push({ label: dr.name, value: dr });
        }
        return this.dropdown;
    }
}